export const navBar = () => {
  return {
    dashboard: 'Dashboard',
    field_forms: 'Field Forms',
    help: 'Help',
    send_feedback: 'Send Feedback',
    log_out: 'Log Out',
    filters: 'Filters',
    access_tab: {
      submit: 'Submit',
      error_message:
        'Your service request could not be sent, please try again.'
    },
    work_orders: 'Work Orders',
    locations: 'Locations',
    account_settings: 'Account Settings',
    company_settings: 'Company Settings'
  }
}
